"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CardMedia_1 = __importDefault(require("../CardMedia"));
var prism_icons_1 = require("@octanner/prism-icons");
var Typography_1 = __importDefault(require("../Typography"));
var styles_1 = require("./styles");
var react_i18next_1 = require("react-i18next");
var MediaLibrary_1 = require("./MediaLibrary");
var MediaCard = function (_a) {
    var setSelected = _a.setSelected, title = _a.title, onMediaSelect = _a.onMediaSelect, onFavorite = _a.onFavorite, media = _a.media, size = _a.size, _b = _a.isFavorite, isFavorite = _b === void 0 ? function () { return false; } : _b;
    var videoRef = react_1.default.useRef(null);
    var _c = __read(react_1.default.useState(true), 2), paused = _c[0], setPaused = _c[1];
    var _d = __read(react_1.default.useState(false), 2), error = _d[0], setError = _d[1];
    var _e = __read(react_1.default.useState(false), 2), favoriteLoading = _e[0], setFavoriteLoading = _e[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if (!paused) {
            if ((_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.play) {
                (_b = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _b === void 0 ? void 0 : _b.play();
            }
        }
        else {
            if ((_c = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _c === void 0 ? void 0 : _c.pause) {
                (_d = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _d === void 0 ? void 0 : _d.pause();
            }
        }
    }, [paused]);
    var onCardPlayClick = function () {
        setPaused(!paused);
    };
    var onCardSelect = function (item) {
        if (onMediaSelect) {
            onMediaSelect(item);
        }
        setSelected(item);
    };
    var imageMedia = (react_1.default.createElement(CardMedia_1.default, { component: media.mediaType, playsInline: true, controlsList: "nodownload", disablePictureInPicture: true, "data-testid": "video", src: (0, MediaLibrary_1.getPreferredMediaUrl)(media.thumbNailUrl, media.normalUrl) ||
            media.largeUrl, title: title, onError: function () {
            setError(true);
        } }));
    return (react_1.default.createElement(styles_1.MediaCardWrapper, null,
        react_1.default.createElement(styles_1.StyledCard, { className: "prism-media-card", isError: error, tabIndex: 0, onClick: function () { return onCardSelect(media); }, onKeyDown: function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onCardSelect(media);
                }
            } },
            error ? (react_1.default.createElement(styles_1.MediaCardContent, null,
                size !== 'auto' && react_1.default.createElement(styles_1.StyledBrokenImage, null),
                react_1.default.createElement(Typography_1.default, { p: 2, variant: size !== 'sm' ? 'body2' : 'body1' }, t('prism-header:media-error', ' This media failed to load.')))) : (react_1.default.createElement(styles_1.StyledCardActionArea, { tabIndex: -1, "data-testid": "media-library-card", "aria-label": media.mediaType === 'img'
                    ? "select ".concat(media.title)
                    : "select ".concat(media.title, " video") }, media.mediaType === 'img' ? (imageMedia) : (react_1.default.createElement(CardMedia_1.default, { ref: videoRef, component: media.mediaType, playsInline: true, controlsList: "nodownload", disablePictureInPicture: true, "data-testid": "video", src: media.mediaUrl, title: title, poster: media.largeUrl || media.thumbNailUrl || media.normalUrl })))),
            onFavorite && (react_1.default.createElement(styles_1.ActionButtonContainer, null,
                react_1.default.createElement(styles_1.FavoriteButtonSmall, { size: "small", isFavorite: isFavorite === null || isFavorite === void 0 ? void 0 : isFavorite(media), disableRipple: true, disableFocusRipple: true, color: "white", loading: favoriteLoading, "aria-label": (isFavorite === null || isFavorite === void 0 ? void 0 : isFavorite(media))
                        ? t('prism-header:unfavorite', 'Unfavorite')
                        : t('prism-header:favorite', 'Favorite'), onClick: function (e) {
                        var _a;
                        e.stopPropagation();
                        var promise = onFavorite(media);
                        if (promise === null || promise === void 0 ? void 0 : promise.then) {
                            setFavoriteLoading(true);
                            (_a = promise.finally) === null || _a === void 0 ? void 0 : _a.call(promise, function () { return setFavoriteLoading(false); });
                        }
                    }, onKeyDown: function (e) {
                        e.stopPropagation();
                    } }, (isFavorite === null || isFavorite === void 0 ? void 0 : isFavorite(media)) ? react_1.default.createElement(prism_icons_1.HeartFilled, null) : react_1.default.createElement(prism_icons_1.Heart, null)))),
            media.mediaType === 'video' && (react_1.default.createElement(styles_1.PlayButton, { tabIndex: 0, disableRipple: true, disableFocusRipple: true, onClick: function (e) {
                    e.stopPropagation();
                    onCardPlayClick();
                }, onKeyDown: function (e) {
                    e.stopPropagation();
                }, "aria-label": paused
                    ? "play ".concat(media.title, " video")
                    : "pause ".concat(media.title, " video"), "aria-live": "polite" }, paused ? react_1.default.createElement(prism_icons_1.Play, null) : react_1.default.createElement(prism_icons_1.Pause, null))))));
};
exports.default = MediaCard;
//# sourceMappingURL=MediaCard.js.map